/**
 * 事件上报
 * @param {Object} params
 */
export function track(params) {
  // 这里自己封装fetch或者axios，在拦截器中实现公共参数上报
  console.log(`Track data to server xxx: ${JSON.stringify(params)}`)
}
